<template>
    <div>
        <navigation-menu />
        <add-new-contact-modal ref="addNewContactModal" />
        <add-new-group-modal ref="addNewGroupModal" />
    </div>
</template>

<script>
    import RecentInvites from '../invites/RecentInviteList';
    import ContactList from './ContactList';
    import ContactsCsvImporter from './ContactsCsvImporter';
    import BlockedContactList from './BlockedContactList';
    import ContactGroups from './ContactGroups';

    import VueRouter from 'vue-router';

    const router = new VueRouter({
        routes: [
            { path: '/recent-invites', component: RecentInvites, label: 'Recent Invites'},
            { path: '/all-contacts', component: ContactList, label: 'All Contacts'},
            { path: '/import-contacts', component: ContactsCsvImporter, label: 'Import Contacts'},
            { path: '/blocked-contacts', component: BlockedContactList, label: 'Blocked Contacts'},
            { path: '/contact-groups', component: ContactGroups, label: 'Contact Groups' },
            { path: '/', redirect: '/all-contacts' },
        ],
        linkActiveClass: 'active',
        linkExactActiveClass: 'exact-active',
    });

    export default {
        router,
    }
</script>
